// extracted by css-extract-rspack-plugin
export default {"container":"VideoPlayer_container__EMMtd","fallback":"VideoPlayer_fallback__GjZvq"};